import { useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Piko } from '../components/Piko';
import { t } from '../core/i18n';
import { parentDashboardPathForGateNext } from '../core/parentNavigation';

export default function ParentGate() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get('next');
  const [stage, setStage] = useState('hold');
  const [progress, setProgress] = useState(0);
  const [target] = useState(() => Math.floor(Math.random() * 7) + 3);
  const [nums] = useState(() => {
    const set = new Set([target]);
    while (set.size < 3) set.add(Math.floor(Math.random() * 9) + 1);
    return [...set].sort(() => Math.random() - 0.5);
  });
  const [wrong, setWrong] = useState(false);
  const timer = useRef(null);

  const startHold = () => {
    const t0 = Date.now();
    timer.current = setInterval(() => {
      const p = Math.min(1, (Date.now() - t0) / 3000);
      setProgress(p);
      if (p >= 1) { clearInterval(timer.current); setStage('task'); }
    }, 60);
  };
  const stopHold = () => { clearInterval(timer.current); if (stage === 'hold') setProgress(0); };

  const pick = (n) => {
    if (n === target) {
      sessionStorage.setItem('pp_parent_gate', '1');
      nav(parentDashboardPathForGateNext(next));
    } else { setWrong(true); setTimeout(() => setWrong(false), 1200); }
  };

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center gap-8 px-6" style={{ background: 'linear-gradient(180deg,#FCF9F2,#E2D4F0)' }}>
      <Piko pose="think" size={110} />
      <h1 className="font-heading text-2xl font-bold text-navy">{t('parentArea')}</h1>
      {stage === 'hold' ? (
        <>
          <p className="font-body text-navy/70">{t('holdToEnter')}</p>
          <button data-testid="parent-gate-hold-btn"
            onPointerDown={startHold} onPointerUp={stopHold} onPointerLeave={stopHold}
            className="relative w-40 h-40 rounded-full bg-white shadow-xl flex items-center justify-center select-none touch-none">
            <svg className="absolute inset-0 -rotate-90" viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="45" fill="none" stroke="#E2D4F0" strokeWidth="7" />
              <circle cx="50" cy="50" r="45" fill="none" stroke="#1D3557" strokeWidth="7"
                strokeDasharray={`${progress * 283} 283`} strokeLinecap="round" />
            </svg>
            <span className="font-heading font-bold text-navy text-lg">{Math.round(progress * 100)}%</span>
          </button>
        </>
      ) : (
        <>
          <p className="font-body text-navy/70" data-testid="gate-task-text">{t('gateTask')} <b className="text-2xl">{target}</b></p>
          <div className="flex gap-4">
            {nums.map((n) => (
              <motion.button key={n} data-testid={`gate-num-${n}`} whileTap={{ scale: 0.9 }}
                animate={wrong ? { x: [0, -6, 6, 0] } : {}}
                onClick={() => pick(n)}
                className="w-20 h-20 rounded-2xl bg-white shadow-lg font-heading text-3xl font-bold text-navy">{n}</motion.button>
            ))}
          </div>
          {wrong && <p className="font-body text-coral font-bold">{t('wrongGate')}</p>}
        </>
      )}
      <button data-testid="gate-back-btn" onClick={() => nav('/home')} className="font-body text-navy/50 underline min-h-[48px]">{t('backHome')}</button>
    </div>
  );
}
